import { getEnvVar } from "common/utilities/ generic";
import { createStore, applyMiddleware, compose } from "redux";
import reduxImmutableStateInvariant from "redux-immutable-state-invariant";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "../../reducers";

export default function configureStore(initialState) {
    const sagaMiddleware = createSagaMiddleware({
        onError(error) {
            setImmediate(() => {
                throw error;
            });
        },
    });

    const middlewares = applyMiddleware(sagaMiddleware, reduxImmutableStateInvariant());

    const isProd = getEnvVar("NODE_ENV") === "production";
    const enhancer = isProd ? compose(middlewares) : composeWithDevTools(middlewares);

    const store = createStore(rootReducer, initialState, enhancer);

    return store;
}
